var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8857 6L13.143 15.2846M17.8857 6H13.0824M17.8857 6H22.6229L21.0148 9.07308M13.143 15.2846H8.39752M13.143 15.2846H10.6477M13.0824 6H8.27909L6.7476 9.07308M13.0824 6L8.39752 15.2846M8.39752 15.2846H3.65205L5.21612 12.1462M5.21612 12.1462H19.4068M5.21612 12.1462L6.7476 9.07308M19.4068 12.1462L17.7645 15.2846H13.8315M19.4068 12.1462L21.0148 9.07308M21.0148 9.07308H6.7476M10.6477 15.2846V23M10.6477 15.2846H13.8315M10.6477 23H2.5M10.6477 23H13.8315M13.8315 23V15.2846M13.8315 23L19.1416 23L22 23",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarHeating);
export default __webpack_public_path__ + "static/media/solar_heating.3351936a693f583ba1633cfc0ec5fe43.svg";
export { ForwardRef as ReactComponent };